<header class="baer-header" *ngIf="report">
    <div *ngIf='report?.assessment' class="breadcrumb"><a routerLink="/assessments">BAER Assessments</a> &gt; <a
            [routerLink]="'/fire-overview'"
            [queryParams]="{assessment_id: report?.assessment?.assessment_id}">{{report?.assessment?.baer_name}}</a>
        &gt; {{ report?.baer_name }} ({{report?.report_num}})</div>
    <h1 id="table" class="site-page-title" *ngIf="report"><span class="large-font">{{report.baer_name}}
            ({{report.report_num}})</span></h1>
    <div class="status-div" *ngIf="report">
        Report ID: {{ report.report_id }} <span class="spacer">|</span>Action: {{ "Initial" }}
    </div>
    <div class="status-div" *ngIf="report">
        Report Status:
        <mat-chip [ngClass]="'chip-r-'+report?.report_status_id">
            {{report.report_status_id | reportStatusBadge}}
        </mat-chip>
        @if (report.report_status_id == 2) {
        <span class="spacer">|</span>Authorization Status:
        <mat-chip [ngClass]="'chip-a-'+report?.authorization_status_id">
            {{report.authorization_status_id | authorizationStatusBadge}}
        </mat-chip>
        }
    </div>
    <div class="button-row">
        <button class="edit-report" (click)="download()"
            *ngIf="report.page_1_status_id == 2 && report.page_2_status_id == 2 && report.page_3_status_id == 2">
            <fa-icon class="fa-sm" [icon]="faFileArrowDown"></fa-icon>Export PDF
        </button>
        <button class="edit-report" *ngIf="editable && canEdit" [routerLink]="'/2500-8-report'"
            [queryParams]="{report_id: report?.report_id}">
            <fa-icon class="fa-sm" [icon]="faEdit"></fa-icon>Edit Report
        </button>
    </div>
</header>
<div class="report-main" *ngIf="report">
    <div class="sticky-container" [ngClass]="sidebar_expand ? '' : 'collapsed-report-nav'">
        <div class="report-nav" [ngClass]="sidebar_expand ? '' : 'collapsed-report-nav'">
            <div class="rnav-header">
                <div *ngIf="sidebar_expand">2500-8 Report</div>
                <button mat-icon-button *ngIf="!sidebar_expand" class="icon-button toggle-button" (click)="sidebar_expand = true"
                    matTooltip="Show report menu" matTooltipClass="tooltipClass"
                    matTooltipPosition="left"><mat-icon>keyboard_tab</mat-icon></button>
                <button mat-icon-button *ngIf="sidebar_expand" class="icon-button toggle-button facing-left" (click)="sidebar_expand = false"
                    matTooltip="Hide report menu" matTooltipClass="tooltipClass"
                    matTooltipPosition="left"><mat-icon>keyboard_tab</mat-icon></button>
            </div>
            @if(sidebar_expand) {
            @for (item of pages; track item; let page = $index) {
            <div
                [ngClass]="'rnav-item rnav-status-'+report['page_'+(page+1)+'_status_id'] +' rnav-current-'+(report_page==page+1)">
                <button class="anchor-button" (click)="scrollIntoView(item.id, 'view-report')">
                    <div class="nav-div" class="nav-div">
                        @if(report['page_'+(page+1)+'_status_id'] == 1){
                        <mat-icon class="current-page">contrast</mat-icon>
                        }
                        @else {
                        @if(report['page_'+(page+1)+'_status_id'] == 2) {<mat-icon>check_circle</mat-icon>}
                        @else {<mat-icon>panorama_fish_eye</mat-icon>}
                        }
                        {{page+1}}. {{item.name}}
                    </div>
                </button>
            </div>
            }

            @if(report_type != "No Treatment") {
            <div class="nav-text" *ngIf="!is_co">                <div class="nav-div gray-nav">
                    To Be completed by RO & WO:
                </div>
            </div>

            <div class="nav-title">
                <div class="nav-div"
                    [ngClass]="lockStatus.regionalFunds && lockStatus.regionalApproval? 'gray-nav-title' : ''">
                    REGIONAL FUNDS
                </div>
            </div>

            <div
                [ngClass]="'rnav-item rnav-status-'+report.regional_funding_status_id +' rnav-current-'+(report_page==8)+' no-hover-'+lockStatus.regionalFunds">
                <button class="anchor-button" [disabled]="lockStatus.regionalFunds"
                    (click)="scrollIntoView('regional-funding', 'regional_funds')">
                    <div class="nav-div" *ngIf="lockStatus.regionalFunds">
                        <div class="lock-div">
                            <fa-icon [icon]="faLock" aria-label="Locked"></fa-icon>
                        </div>
                        Regional Funding Recommendations
                    </div>
                    <div class="nav-div" *ngIf="!lockStatus.regionalFunds">
                        @if(report.regional_funding_status_id == 1){
                        <mat-icon class="current-page">contrast</mat-icon>
                        }
                        @else {
                        @if(report.regional_funding_status_id == 2) {<mat-icon>check_circle</mat-icon>}
                        @else {<mat-icon>panorama_fish_eye</mat-icon>}
                        }
                        Regional Funding Recommendations
                    </div>
                </button>
            </div>
            <div
                [ngClass]="'rnav-item rnav-status-'+report.regional_approval_status_id +' rnav-current-'+(report_page==8)+' no-hover-'+lockStatus.regionalApproval">
                <button class="anchor-button" [disabled]="lockStatus.regionalApproval"
                    (click)="scrollIntoView('regional-approval', 'regional_funds')">
                    <div class="nav-div" *ngIf="lockStatus.regionalApproval">
                        <div class="lock-div">
                            <fa-icon [icon]="faLock" aria-label="Locked"></fa-icon>
                        </div>
                        Regional Approval & Certification
                    </div>
                    <div class="nav-div" *ngIf="!lockStatus.regionalApproval">
                        @if(report.regional_approval_status_id == 1){
                        <mat-icon class="current-page">contrast</mat-icon>
                        }
                        @else {
                        @if(report.regional_approval_status_id == 2) {<mat-icon>check_circle</mat-icon>}
                        @else {<mat-icon>panorama_fish_eye</mat-icon>}
                        }
                        Regional Approval & Certification
                    </div>
                </button>
            </div>

            @if(requiresWOFunding) {
            <div class="nav-title">
                <div class="nav-div" [ngClass]="lockStatus.woFunds && lockStatus.woApprovals? 'gray-nav-title' : ''">
                    WO FUNDS
                </div>
            </div>

            <div
                [ngClass]="'rnav-item rnav-status-'+report.wo_funding_status_id +' rnav-current-'+(report_page==8)+' no-hover-'+lockStatus.woFunds">
                <button class="anchor-button" [disabled]="lockStatus.woFunds"
                    (click)="scrollIntoView('wo-funding', 'wo_funds')">
                    <div class="nav-div" *ngIf="lockStatus.woFunds">
                        <div class="lock-div">
                            <fa-icon [icon]="faLock" aria-label="Locked"></fa-icon>
                        </div>
                        WO Funding Recommendations
                    </div>
                    <div class="nav-div" *ngIf="!lockStatus.woFunds">
                        @if(report.wo_funding_status_id == 1){
                        <mat-icon class="current-page">contrast</mat-icon>
                        }
                        @else {
                        @if(report.wo_funding_status_id == 2) {<mat-icon>check_circle</mat-icon>}
                        @else {<mat-icon>panorama_fish_eye</mat-icon>}
                        }
                        WO Funding Recommendations
                    </div>
                </button>
            </div>
            <div
                [ngClass]="'rnav-item rnav-status-'+report.wo_approval_status_id +' rnav-current-'+(report_page==8)+' no-hover-'+lockStatus.woApprovals">
                <button class="anchor-button" [disabled]="lockStatus.woApprovals"
                    (click)="scrollIntoView('wo-approval', 'wo_funds')">
                    <div class="nav-div" *ngIf="lockStatus.woApprovals">
                        <div class="lock-div">
                            <fa-icon [icon]="faLock" aria-label="Locked"></fa-icon>
                        </div>
                        WO Approval & Certification
                    </div>
                    <div class="nav-div" *ngIf="!lockStatus.woApprovals">
                        @if(report.wo_approval_status_id == 1){
                        <mat-icon class="current-page">contrast</mat-icon>
                        }
                        @else {
                        @if(report.wo_approval_status_id == 2) {<mat-icon>check_circle</mat-icon>}
                        @else {<mat-icon>panorama_fish_eye</mat-icon>}
                        }
                        WO Approval & Certification
                    </div>
                </button>
            </div>
            }
            }
            }
        </div>
    </div>
    <div class="report-right-area">
        <div class="report-area" *ngIf="section() == 'view-report' || section() == undefined">
            <div #target1 class="report-section" [ngClass]="(comment_expand ? 'report-section-comment ' : '') + (sidebar_expand ? 'side-bar-expand' : ' ')"
                *ngIf="report">
                <ng-container *ngTemplateOutlet="underReview"></ng-container>
                <ng-container *ngTemplateOutlet="submitted"></ng-container>
                <ng-container *ngTemplateOutlet="regionalFundingRecommendation"></ng-container>
                @if(report_type == "No Treatment") {
                <app-view-report-type id="report-type" [report]="report"></app-view-report-type>
                <app-view-burned-area id="burned-area" [report]="report"
                    (loaded)="subLoaded($event)"></app-view-burned-area>
                <app-view-watershed-condition id="watershed-condition" [report]="report"
                    (loaded)="subLoaded($event)"></app-view-watershed-condition>
                <app-view-analysis-summary id="analysis-summary" [report]="report"
                    (loaded)="subLoaded($event)" [forPDF]="false"></app-view-analysis-summary>
                <app-view-recommended-treatment id="recommended-treatment" [report]="report"
                    (loaded)="subLoaded($event)"></app-view-recommended-treatment>
                <app-view-assessment-cost id="assessment-cost" [report]="report"
                    (loaded)="subLoaded($event)"></app-view-assessment-cost>
                <app-view-team-supporting id="team-supporting" [report]="report" page="6"
                    (loaded)="subLoaded($event)"></app-view-team-supporting>
                <app-view-select-line-officer id="select-line-officer" [report]="report" page="7"
                    (loaded)="subLoaded($event)"></app-view-select-line-officer>
                <app-view-lo-signatures id="view-lo-signatures" [report]="report"></app-view-lo-signatures>
                } @else if (report_type == "Pre-assessment Request") {
                <app-view-report-type id="report-type" [report]="report"></app-view-report-type>
                <app-view-burned-area id="burned-area" [report]="report" [simple]="true"
                    (loaded)="subLoaded($event)"></app-view-burned-area>
                <app-view-analysis-summary id="analysis-summary" [report]="report" [simple]="true"
                    (loaded)="subLoaded($event)" [forPDF]="false"></app-view-analysis-summary>
                <app-view-recommended-treatment id="recommended-treatment" [report]="report"
                    (loaded)="subLoaded($event)"></app-view-recommended-treatment>
                <app-view-emergency-stabilization id="emergency-stabilization" [report]="report"
                    (loaded)="subLoaded($event)"></app-view-emergency-stabilization>
                <app-view-team-supporting id="team-supporting" [report]="report" page="6"
                    (loaded)="subLoaded($event)"></app-view-team-supporting>
                <app-view-select-line-officer id="select-line-officer" [report]="report" page="7"
                    (loaded)="subLoaded($event)"></app-view-select-line-officer>
                <app-view-lo-signatures id="view-lo-signatures" [report]="report"></app-view-lo-signatures>
                } @else {
                <app-view-report-type id="report-type" [report]="report"></app-view-report-type>
                <app-view-burned-area id="burned-area" [report]="report"
                    (loaded)="subLoaded($event)"></app-view-burned-area>
                <app-view-watershed-condition id="watershed-condition" [report]="report"
                    (loaded)="subLoaded($event)"></app-view-watershed-condition>
                <app-view-analysis-summary id="analysis-summary" [report]="report"
                    (loaded)="subLoaded($event)" [forPDF]="false"></app-view-analysis-summary>
                <app-view-recommended-treatment id="recommended-treatment" [report]="report"
                    (loaded)="subLoaded($event)"></app-view-recommended-treatment>
                <app-view-emergency-stabilization id="emergency-stabilization" [report]="report"
                    (loaded)="subLoaded($event)"></app-view-emergency-stabilization>
                <app-view-team-supporting id="team-supporting" [report]="report"
                    (loaded)="subLoaded($event)"></app-view-team-supporting>
                <app-view-select-line-officer id="select-line-officer" [report]="report"
                    (loaded)="subLoaded($event)"></app-view-select-line-officer>
                <app-view-lo-signatures id="view-lo-signatures" [report]="report"></app-view-lo-signatures>
                }
            </div>
            <div class="sticky-container" [ngClass]="comment_expand ? 'expand-comment' : ''">
                <div class="report-comments" [ngClass]="comment_expand ? 'expand-comment' : ''"
                    *ngIf="report_page != 9">

                    @if(comments_unresolved) {
                    <button mat-icon-button aria-label="chat_button" class="icon-button" (click)="comment_expand = true"
                        *ngIf="!comment_expand">
                        <fa-icon [icon]="faMessage" class="chat-count-red" aria-label="chat"></fa-icon><span
                            class="button-text chat-text-red">{{comments?.length ?? 0}}</span>
                    </button>
                    } @else {
                    <button mat-icon-button aria-label="chat_button" class="icon-button" (click)="comment_expand = true"
                        *ngIf="!comment_expand">
                        <fa-icon [icon]="faMessage" class="chat-count" aria-label="chat"></fa-icon><span
                            class="button-text chat-text">{{comments?.length ?? 0}}</span>
                    </button>
                    }
                    <div class="comment-header" *ngIf="comment_expand">
                        <button class="comment-button">
                            Comments<span>({{comments?.length ?? 0}})</span></button>
                        <button class="comment-add-button" *ngIf="comment_expand && is_co" (click)="addComment()"
                            matTooltip="Add comment" matTooltipClass="tooltipClass">
                            <mat-icon>add</mat-icon></button>
                        <button mat-icon-button class="icon-button" (click)="comment_expand = false"
                            matTooltip="Hide comments" matTooltipClass="tooltipClass"
                            matTooltipPosition="left"><mat-icon>keyboard_tab</mat-icon></button>
                    </div>
                    <div class="no-comments" *ngIf="comment_expand && ((comments?.length ?? 0) == 0)">
                        <fa-icon [icon]="faCommentSlash" class="chat-count" aria-label="no messages"></fa-icon>
                        <div class="no-comments-title">No Comments</div>
                        <div class="no-comments-text" *ngIf="!is_co">
                            No revisions have been requested
                        </div>
                        <div class="no-comments-text" *ngIf="is_co">
                            Leave a comment to request revisions to the report
                        </div>
                        <button class="comment-add-button" *ngIf="comment_expand && is_co"
                            (click)="addComment()"><mat-icon>add</mat-icon> Add Comment</button>
                    </div>
                    <div class="comments" *ngIf="comment_expand && ((comments?.length ?? 0) > 0)">
                        @for(comment of comments; track comment) {
                        <mat-card>
                            <mat-card-header>
                                <mat-card-title>
                                    <a [routerLink]="'/2500-8-report'" *ngIf="editable && canEdit"
                                        [queryParams]="{report_id: report.report_id, report_page_input: comment.section}">
                                        {{comment.section}}. {{findPage(comment.section) }}
                                    </a>
                                    <span *ngIf="!(editable && canEdit)">
                                        {{comment.section}}. {{findPage(comment.section) }}
                                    </span>
                                </mat-card-title>
                                <div class="comment-title-align">
                                    <mat-icon class="resolved" matTooltip="Resolved" matTooltipClass="tooltipClass"
                                        matTooltipPosition="left" *ngIf="comment.resolved && is_co">check</mat-icon>
                                    <button *ngIf="!is_co && !comment.resolved" class="resolve-button" mat-icon-button
                                        (click)="markAsResolved(comment, true)" aria-label="Mark as Resolved"
                                        matTooltip="Mark as Resolved" matTooltipClass="tooltipClass"
                                        matTooltipPosition="left">
                                        <mat-icon class="unresolved-icon">panorama_fish_eye</mat-icon>
                                    </button>
                                    <button *ngIf="!is_co && comment.resolved" class="resolve-button" mat-icon-button
                                        (click)="markAsResolved(comment, false)" aria-label="Mark as Unresolved"
                                        matTooltip="Mark as Unresolved" matTooltipClass="tooltipClass"
                                        matTooltipPosition="left">
                                        <mat-icon class="resolved-icon">check</mat-icon>
                                    </button>
                                    <button *ngIf="is_co" class="comment-menu" mat-icon-button
                                        [matMenuTriggerFor]="menu" aria-label="Comment Menu" matTooltip="Actions menu"
                                        matTooltipClass="tooltipClass" matTooltipPosition="left">
                                        <mat-icon>more_horiz</mat-icon>
                                    </button>
                                    <mat-menu #menu="matMenu">
                                        <button class="comment-edit" mat-menu-item (click)="editComment(comment)">
                                            <fa-icon class="fa-sm" [icon]="faEdit" style="color: #216E1F;"></fa-icon>
                                            <span>Edit</span>
                                        </button>
                                        <button class="comment-delete" mat-menu-item (click)="deleteComment(comment)">
                                            <fa-icon class="fa-sm" [icon]="faTrash"></fa-icon>
                                            <span>Delete</span>
                                        </button>
                                    </mat-menu>
                                </div>
                            </mat-card-header>
                            <mat-card-content>
                                <span class="comment-info"><b>{{comment.commentator_name}}</b> • {{comment.updated_on |
                                    date:"MM/dd/yyyy"}}</span>
                                <span class="comment-detail">{{comment.comment}}</span>
                            </mat-card-content>
                        </mat-card>
                        }
                    </div>

                </div>
            </div>
        </div>

        <div class="report-area" *ngIf="section() == 'regional_funds'">
            <div class="report-section" *ngIf="report">
                <ng-container *ngTemplateOutlet="regionalFundingRecommendation"></ng-container>
                <app-regional-funding id="regional-funding" [report]="report"
                    [updateReportSubject]="updateReportSubject" [autosave]="autosave"
                    [readySubject]="readyStatus"></app-regional-funding>
                <app-select-regional-officer id="regional-approval"
                    *ngIf="is_roco && report.authorization_status_id == 3" [report]="report"
                    [loSelected]="loSelected"></app-select-regional-officer>
                <app-view-regional-officer id="regional-approval" *ngIf="report.authorization_status_id != 3"
                    [report]="report"></app-view-regional-officer>
                <app-view-ro-signatures id="regional-signatures" [report]="report"></app-view-ro-signatures>
            </div>
        </div>
        <div class="report-area" *ngIf="section() == 'wo_funds'">
            <div class="report-section" *ngIf="report">
                <app-wo-funding id="wo-funding" [report]="report" [updateReportSubject]="updateReportSubject"
                    [autosave]="autosave" [readySubject]="readyStatus"></app-wo-funding>
                <app-select-wo-officer id="wo-approval" *ngIf="is_woco && report.authorization_status_id == 5"
                    [report]="report" [loSelected]="loSelected"></app-select-wo-officer>
                <app-view-wo-officer id="wo-approval" *ngIf="report.authorization_status_id != 5"
                    [report]="report"></app-view-wo-officer>
                <app-view-wo-signatures id="wo-signatures" [report]="report"></app-view-wo-signatures>
            </div>
        </div>
        <div class="report-footer" *ngIf="signable">
            <div class="rf-left">

            </div>
            <div class="rf-right">
                <div class="saving-div auto-save" *ngIf="autosave.saving">
                    <div>
                        <mat-spinner style="margin-right: 10px" [color]="'accent'" [diameter]="20"></mat-spinner>
                    </div>
                    Saving...
                </div>
                <div class="saving-div auto-save" *ngIf="autosave.saved">
                    <fa-icon [icon]="faCheck" class="save-check" aria-label="check"></fa-icon>
                    {{ savedText }}
                </div>
                <button class="submit-btn" (click)="sign()" *ngIf="true" color="accent" [disabled]="false"><span>Sign &
                        Certify Report</span>
                    <mat-icon>send</mat-icon></button>
            </div>
        </div>
        <div class="report-footer" *ngIf="submitable">
            <div class="rf-left">

            </div>
            <div class="rf-right">
                <div class="saving-div auto-save" *ngIf="autosave.saving">
                    <div>
                        <mat-spinner style="margin-right: 10px" [color]="'accent'" [diameter]="20"></mat-spinner>
                    </div>
                    Saving...
                </div>
                <div class="saving-div auto-save" *ngIf="autosave.saved">
                    <fa-icon [icon]="faCheck" class="save-check" aria-label="check"></fa-icon>
                    {{ savedText }}
                </div>
                <button class="submit-btn" (click)="submitFunding()" *ngIf="true" color="accent"
                    [disabled]="!this.readyStatusBoolean || !this.loSelectedBoolean"><span>Submit for Certification & Approval</span>
                    <mat-icon>send</mat-icon></button>
            </div>
        </div>
    </div>
</div>

<ng-template #underReview>
    <div class="yellow-warning" *ngIf="report.report_status_id == 3 && !is_roco">
        <fa-icon [icon]="faFile" class="faFile" aria-label="Warning"></fa-icon>
        <div class="support-text">
            <b>The report is under review by the Regional BAER Coordinator.</b>
            <span>
                <br>
            </span>
            If additional information or changes are requested you will be notified in the Comments sidebar.
        </div>
    </div>
</ng-template>
<ng-template #readyRegionalFunding>
    <div class="yellow-warning">
        <fa-icon [icon]="faWarning" class="faWarning" aria-label="Warning"></fa-icon>
        <div class="support-text">
            <b>Report is ready for Regional Funding Recommendations.</b>
        </div>
    </div>
</ng-template>
<ng-template #submitted>
    <div class="green-box" *ngIf="report.report_status_id == 2 && report.authorization_status_id == 0">
        <i class="material-icons check-icon">check_circle</i>
        <div class="support-text">
            <b>Report submitted to the forest unit line officer(s) for signature and certification.</b>
            <span>
                <br>
            </span>
            Report submitted on {{ report.submission_date | date:"MM/dd/yyyy" }}
        </div>
    </div>
</ng-template>
<ng-template #regionalFundingRecommendation>
    <div class="yellow-warning" *ngIf="report.report_status_id == 2 && report.authorization_status_id == 3">
        <fa-icon [icon]="faWarning" class="faWarning" aria-label="Warning"></fa-icon>
        <div class="support-text">
            <b>Report is Ready for Regional Funding Recommendations.</b>
        </div>
    </div>
</ng-template>